var __defProp = Object.defineProperty;
var __name = (target, value) => __defProp(target, "name", { value, configurable: !0 });
import { s as size, _ as __spreadValues } from "./chunk-JJ6VZ5V7-514ab153.mjs";
import * as React from "react";
import { s as styled, c as color } from "./lib-d8694455.mjs";
import "@aircall/icons";
import "@aircall/tractor-v2";
import "styled-components";
import "react-router-dom";
import "@aircall/hooks";
import "react-final-form";
import "react-dom";
import "react-router";
import "final-form";
var SvgComponent = /* @__PURE__ */ __name((props) => /* @__PURE__ */ React.createElement(
  "svg",
  __spreadValues({
    xmlns: "http://www.w3.org/2000/svg",
    width: "24px",
    height: "24px",
    fill: "none",
    viewBox: "0 0 32 32"
  }, props),
  /* @__PURE__ */ React.createElement(
    "path",
    {
      fill: "#1AAF5D",
      fillRule: "evenodd",
      d: "M31.683 10.667H.34c.131-.925.305-1.86.526-2.792 0 0 1.03-4.918 5.476-6.646C8.433.432 12.25.033 16 0c3.75.033 7.567.432 9.69 1.263 4.448 1.728 5.477 6.646 5.477 6.646.22.916.39 1.84.516 2.758Z",
      clipRule: "evenodd"
    }
  ),
  /* @__PURE__ */ React.createElement(
    "path",
    {
      fill: "#fff",
      fillRule: "evenodd",
      d: "M.34 10.667h31.343c.254 1.844.336 3.663.314 5.35a34.717 34.717 0 0 1-.337 5.316H.325a34.916 34.916 0 0 1-.322-5.35c-.022-1.66.074-3.469.337-5.316Z",
      clipRule: "evenodd"
    }
  ),
  /* @__PURE__ */ React.createElement(
    "path",
    {
      fill: "#E94B35",
      fillRule: "evenodd",
      d: "M.325 21.333H31.66a30.81 30.81 0 0 1-.527 2.791s-1.028 4.918-5.476 6.646C23.567 31.6 19.75 31.966 16 32c-3.75-.034-7.567-.432-9.658-1.23C1.895 29.042.866 24.124.866 24.124c-.232-.93-.41-1.865-.54-2.79Z",
      clipRule: "evenodd"
    }
  ),
  /* @__PURE__ */ React.createElement(
    "path",
    {
      fill: "#227FBB",
      fillRule: "evenodd",
      d: "M2.406 4.442 8.666 16l-6.26 11.558C1.22 25.812.866 24.124.866 24.124c-.697-2.79-.896-5.615-.863-8.14-.033-2.493.2-5.318.863-8.109 0 0 .353-1.688 1.54-3.433Z",
      clipRule: "evenodd"
    }
  ),
  /* @__PURE__ */ React.createElement(
    "path",
    {
      fill: "#000",
      fillRule: "evenodd",
      d: "M19.1 17.903V13l-.1-.1h-5l-.1.1.002.476a1265.707 1265.707 0 0 1 .011 4.316c0 .983.423 1.248 1.37 1.235l.068-.001.067-.002c.675-.015.895.042.994.34l.12.363.073-.374c.055-.282.261-.334.946-.313l.194.006c.92.015 1.355-.244 1.355-1.143Zm-5-4.803h4.8v4.803c0 .76-.33.956-1.152.943l-.19-.005c-.618-.02-.921.019-1.064.242-.17-.229-.475-.272-1.08-.259l-.067.002h-.066c-.85.013-1.168-.186-1.168-1.034a666.384 666.384 0 0 0-.007-3.125l-.004-1.192-.002-.375Z",
      clipRule: "evenodd"
    }
  ),
  /* @__PURE__ */ React.createElement(
    "path",
    {
      fill: "#000",
      fillRule: "evenodd",
      d: "M14.444 19.268a2.188 2.188 0 0 1-.489-.115c-.543-.21-.852-.54-.996-.89a.466.466 0 0 1 .058-.144c.005 0 .016.006.113.07.11.071.195.106.302.1l.094-.079c.027-.132-.01-.256-.1-.387a1.628 1.628 0 0 0-.134-.166 14.212 14.212 0 0 0-.152-.165c-.2-.22-.3-.387-.333-.593-.018-.119-.192-.11-.199.01-.013.239-.05.447-.113.694-.183.708-.193.83.117 1.034a5.694 5.694 0 0 1-.143.376c.11.536.572.895 1.27 1.113.413.129.85.193 1.234.215v.148c0 .574 3.092.574 3.092 0v-.147c.38-.021.816-.084 1.23-.212.704-.218 1.17-.578 1.274-1.118l-.014-.073c-.065-.1-.125-.25-.177-.43.263-.2.249-.306.06-.99a3.155 3.155 0 0 1-.123-.705c-.006-.12-.18-.129-.198-.01-.033.206-.131.372-.325.592a8.343 8.343 0 0 0-.281.333c-.087.13-.123.254-.095.386l.093.08c.104.005.186-.03.293-.103a.632.632 0 0 1 .107-.068s.026.038.059.153l.056.215c-.143.269-.437.567-.932.762a2.201 2.201 0 0 1-.489.114 4.277 4.277 0 0 1-1.177-.026s-.14.177-.14.211c0 .113.06.203.184.214.325.046.364.07.346.142l-.002.065c-.403.16-2.12.143-2.58-.012 0 0 .004-.15.332-.196.116-.01.173-.096.185-.207.012-.119-.133-.217-.133-.217a4.257 4.257 0 0 1-1.174.026Zm5.8-1.696a4.012 4.012 0 0 1-.08-.337 2.14 2.14 0 0 1-.222.293 9.11 9.11 0 0 0-.265.312.425.425 0 0 0-.063.132.557.557 0 0 0 .03-.017c.067-.041.224-.137.289-.13.109.014.174.11.228.3l.047.26c.215-.154.213-.175.037-.813Zm-1.08 1.768c-.16.06-.34.102-.536.127-.313.04-.645.036-.964.006-.042-.008-.066-.007-.054-.006l.054.006c.111.02.348.095.348.361v.103l-.047.085c-.37.23-2.447.209-2.876-.003l-.05-.152c-.07-.202.27-.345.37-.387.023-.009.034-.013.026-.013a4.445 4.445 0 0 1-1.016 0 2.386 2.386 0 0 1-.535-.127c-.614-.238-.964-.622-1.127-1.085.069-.211.126-.321.237-.334h.004a.246.246 0 0 1 .052-.004c.036.004.07.026.186.102l.003.002a.593.593 0 0 0 .089.05.417.417 0 0 0-.066-.135 1.449 1.449 0 0 0-.119-.145 2.122 2.122 0 0 0-.077-.084l-.074-.081a2.114 2.114 0 0 1-.231-.297c-.02.105-.043.21-.072.324-.172.666-.172.692.093.855l.044.111a1.683 1.683 0 0 1-.152.392c.106.428.506.73 1.124.924.428.134.89.196 1.279.211l.096.1v.243c0 .307 2.692.307 2.692 0v-.243l.096-.1a5.088 5.088 0 0 0 1.275-.207c.624-.193 1.026-.497 1.128-.927a2.16 2.16 0 0 1-.196-.512c-.18.342-.502.643-1.004.84Z",
      clipRule: "evenodd"
    }
  ),
  /* @__PURE__ */ React.createElement(
    "path",
    {
      fill: "#73452B",
      fillRule: "evenodd",
      d: "M16.469 14.645h.19a4.21 4.21 0 0 0-.005.488c.151-.223.372-.379.372-.379l.107.133c-.402.304-.472.823-.437 1.578.01.278.01.636.054.98.062.438.187.808.196 1.087.005.093-.735.069-.799.06-.064-.01-.123-.178-.118-.19.328-.976.47-3.124.168-3.358l.018-.209c.085.04.166.171.202.237.023-.246.052-.427.052-.427Z",
      clipRule: "evenodd"
    }
  ),
  /* @__PURE__ */ React.createElement(
    "path",
    {
      fill: "#1AAF5D",
      fillRule: "evenodd",
      d: "M16.604 13.454a.2.2 0 0 1 .186.057l.378.394a.2.2 0 0 0 .223.045l.204-.088a.2.2 0 0 1 .21.033l.698.607a.2.2 0 0 1-.016.315l-.59.412a.2.2 0 0 1-.21.012l-.734-.393a.2.2 0 0 0-.094-.024h-.355a.2.2 0 0 0-.14.057l-.486.475a.2.2 0 0 1-.155.057l-.713-.056a.196.196 0 0 1-.041-.384l.223-.067a.2.2 0 0 0 .142-.191v-.119a.2.2 0 0 1 .049-.13l.749-.869a.2.2 0 0 1 .11-.065l.362-.078Z",
      clipRule: "evenodd"
    }
  ),
  /* @__PURE__ */ React.createElement(
    "path",
    {
      fill: "#F2C500",
      fillRule: "evenodd",
      d: "m16.4 11.865-.319.013-.16.255-.173-.243-.32.011.146-.256-.174-.243.333-.013.145-.256.174.244.319-.012-.145.257.174.243Zm-1.2.245-.298.073-.08.284-.217-.214-.284.07.081-.284-.202-.216.284-.071.08-.285.217.213.297-.07-.095.286.217.215Zm-1.2.426-.26.143-.013.321-.247-.177-.26.142.027-.321-.247-.178.26-.145.026-.321.234.177.26-.142-.014.321.234.18Zm2.6-.671.324.013.147.255.176-.243.324.011-.147-.256.176-.243-.323-.013-.162-.256-.177.244-.323-.012.147.257-.162.243Zm1.2.245.284.073.08.284.217-.214.284.07-.081-.284.216-.216-.297-.071-.082-.285-.216.213-.284-.07.082.286-.203.215Zm1.2.426.26.143.013.321.247-.177.26.142-.014-.321.234-.178-.26-.145-.013-.321-.247.177-.26-.142.027.321-.247.18Z",
      clipRule: "evenodd"
    }
  )
), "SvgComponent"), SvgFlagGnq = styled(SvgComponent)`
  ${size}
  ${color}
`, FlagGnq_default = SvgFlagGnq;
export {
  FlagGnq_default as default
};
